import { DotChip } from "@/components/shared/DotChip";
import { LocalizedLink } from "@/components/LocalizedLink";
import { usePlanGate } from "@/hooks/usePlanGate";
import { useLanguage } from "@/hooks/useLanguage";
import { useOrganization } from "@/hooks/useOrganization";
import { notOwnerNote, readOnlyCopy } from "@/lib/billing/entitlements";

/**
 * The company has no plan (trial over, cancelled, a failed payment past its
 * grace): one line saying what stopped and what still works. Everyone in the
 * company sees it; the owner gets the way to the plans. Renders nothing until
 * the gates are on (billing visible and enforced).
 */
export function ReadOnlyBanner() {
  const { active, entitlements } = usePlanGate();
  const { language } = useLanguage();
  const locale = language === "en" ? "en" : "cs";
  const { currentOrganization } = useOrganization();
  if (!active || !entitlements?.readOnly) return null;

  const c = readOnlyCopy(locale);
  const isOwner = currentOrganization?.role === "owner";
  return (
    <div
      role="status"
      className="mb-6 flex flex-wrap items-center gap-x-4 gap-y-1 rounded-lg border bg-card px-4 py-2.5"
    >
      <DotChip color="amber" className="text-[13px] text-foreground">
        {c.title}
      </DotChip>
      <span className="text-[13px] text-muted-foreground">
        {c.stopped} {c.works}
      </span>
      {isOwner ? (
        <LocalizedLink
          to="/settings/billing"
          className="text-[13px] font-medium text-[hsl(var(--action))] hover:underline dark:text-primary"
        >
          {c.cta}
        </LocalizedLink>
      ) : (
        <span className="text-[13px] text-muted-foreground">{notOwnerNote(locale)}</span>
      )}
    </div>
  );
}
